<template>
<section id="main">
  <div class="container">
    <div class="row gtr-200">
      <div class="col-12 about-us">
        <!-- Highlight -->
        <section class="box highlight">
          <header>
            <h2>{{ $t('eslogan') }}</h2>
          </header>
          <p>
            {{ $t('services_description') }}
          </p>
          <ul class="special">
            <li>
              <a href="#" class="icon solid fa-tools">
                <span class="label">Tools</span>
              </a>
              <p>{{ $t('service_radiator') }}</p>
            </li>
            <li>
              <a href="#" class="icon solid fa-hammer">
                <span class="label">Hammer</span>
              </a>
              <p>{{ $t('service_mechanic') }}</p>
            </li>
            <li>
              <a href="#" class="icon solid fa-cogs">
                <span class="label">Cog</span>
              </a>
              <p>{{ $t('service_welding') }}</p>
            </li>
          </ul>
        </section>
      </div>
    </div>
  </div>
</section>
</template>

<script>
export default {
  name: 'AboutUs'
}
</script>

<style lang="less" scoped>
.special li {
  width: 33%;
  vertical-align: top;
}

.special li  a.icon.solid:before {
  margin: 0 auto;
}

.special li  a.icon.solid + p {
  margin: 0.5em auto;
}

@media only screen and ( max-width: 480px ) {

  .special li {
    width: 100%;
  }

}
</style>
